import { hasPermission } from '@/utils/permission'

/**
 * 按钮级权限指令
 *
 * 用法：
 *   <a-button v-permission="'admin'">仅管理员可见</a-button>
 *   <a-button v-permission="['admin', 'dev']">管理员 / 开发者可见</a-button>
 *   <a-button v-permission="PERMISSIONS.CHANNEL_DELETE">删除</a-button>
 *
 * 无权限时直接从 DOM 中移除该元素，避免通过样式隐藏被绕过。
 * 角色在路由守卫中于进入页面前已就绪，因此 inserted 时机即可准确判断。
 */
export default {
  inserted(el, binding) {
    if (!hasPermission(binding.value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el)
      } else {
        el.style.display = 'none'
      }
    }
  }
}
